import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import ContactModalEdit from './ContactModalEdit';

export default function ContactModalEditRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  const context = useOutletContext<any>();

  if (!context?.contact) return null;

  return (
    <ContactModalEdit
      contactId={id!}
      contactType={context.contact.type}
      currentData={{
        name: context.contact.name,
        taxId: context.contact.document,
        taxRootId: context.contact.rootDocument,
        observation: context.contact.observation,
        farol: context.contact.farol || '',
        socialMedia: context.contact.socialMedia,
        city: context.contact.city,
        state: context.contact.state,
        nickname: context.contact.nickname,
        birthDate: context.contact.birthDate,
        jobTitle: context.contact.jobTitle,
        segment: context.contact.clientInfo?.segment,
        employees: context.contact.clientInfo?.employees,
        revenue: context.contact.clientInfo?.revenue,
        size: context.contact.clientInfo?.size,
        isHeadquarters: context.contact.clientInfo?.isHeadquarters,
      }}
      onClose={() => navigate(`/communication/contact/${id}/page-view`)}
      onSuccess={context.onContactUpdate}
    />
  );
}
